import React from "react";
import styles from "./appGrid.module.less";

export interface AppGridItem {
  name: string;
  icon?: string;
  backgroundColor?: string; // 应用背景色
  current?: boolean;
  key?: string;
  url?: string;
}

export interface AppGridSection {
  title: string;
  apps: AppGridItem[];
}

export interface AppGridProps {
  /** 应用分组数据 */
  sections: AppGridSection[];
  /** 点击应用卡片的回调 */
  onAppClick?: (app: AppGridItem) => void;
  /** 自定义样式类名 */
  className?: string;
}

/**
 * 纯UI组件：应用网格
 * 用于展示应用列表的网格布局
 */
export const AppGrid: React.FC<AppGridProps> = ({
  sections,
  onAppClick,
  className = "",
}) => {
  const isSingleSection = sections.length === 1;
  
  return (
    <div className={`${styles.appGrid} ${isSingleSection ? styles.singleSection : ''} ${className}`}>
      <div className={styles.gridContainer}>
        {sections.map((section, sectionIndex) => (
          <React.Fragment key={sectionIndex}>
            <div className={styles.appSection}>
              <div className={styles.sectionTitle}>{section.title}</div>
              <div className={styles.appCards}>
                {section.apps.map((app) => (
                    <div
                      key={app.name}
                      className={`${styles.appCard} ${app.current ? styles.current : ""}`}
                      onClick={() => onAppClick?.(app)}
                    >
                      <div
                        className={styles.appIcon}
                        style={{ backgroundColor: "#167df0" }}
                      >
                        {app.icon ? <img src={app.icon} alt={app.name} style={{ width: "20px", height: "20px" }} /> : app.name?.charAt(0)}
                      </div>
                      <div className={styles.appName} title={app.name}>{app.name}</div>
                    </div>
                ))}
              </div>
            </div>
            {/* 添加分割线节点，除了最后一个分组 */}
            {sectionIndex < sections.length - 1 && (
              <div className={styles.divider}></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
